const LOGIN_FORM_INPUTS = [
  {
    id: 'username',
    element: 'input',
    type: 'text',
    required: 'required',
    value: '',
    multiSelectEnabled: false,
    placeholder: 'Enter username',
    tooltip: 'Username',
    tooltipQuestion: 'What is this?',
    label: 'Username',
    rowClassName: '',
    validation: {
      requirement: 'A username is required',
      algorithm: 'range',
      min: 4,
      max: 64,
    },
    row: 0,
    col: 12,
  },
  {
    id: 'password',
    element: 'input',
    type: 'password',
    required: 'required',
    value: '',
    multiSelectEnabled: false,
    placeholder: 'Enter password',
    tooltip: 'Password',
    tooltipQuestion: 'What is this?',
    label: 'Password',
    rowClassName: '',
    validation: {
      requirement: 'A password is required',
      algorithm: 'range',
      min: 4,
      max: 128,
    },
    row: 1,
    col: 12,
  },
  {
    id: '',
    element: 'input',
    type: 'link',
    required: '',
    value: '',
    label: '',
    rowClassName: '',
    validation: {},
    to: 'reset',
    text: 'Forgot password?',
    row: 2,
    col: 5,
  },
  {
    id: '',
    element: 'space',
    type: 'space',
    required: '',
    value: '',
    label: '',
    rowClassName: '',
    row: 2,
    col: 3,
  },
  {
    id: 'login',
    element: 'input',
    type: 'button',
    required: '',
    value: '',
    placeholder: 'Enter login',
    label: '',
    rowClassName: '',
    validation: {},
    route: 'user/login',
    successActions: [
      {
        action: 'setCookie',
        cookieField: 'token',
        dataField: 'token',
      },
      {
        action: 'setCookie',
        cookieField: 'user',
        dataField: 'user',
      },
      {
        action: 'init',
        dataField: 'push',
      },
      {
        action: 'init',
        dataField: 'notification',
      },
      {
        action: 'setState',
        dataField: '',
        id: 'title',
        data: '',
      },
    ],
    title: 'Login',
    row: 2,
    col: 4,
  },
];

export { LOGIN_FORM_INPUTS };
